import i18n from '@/utils/i18n';
import React from 'react';
import { AMOUNT_BUCKET_MIN_WIDTH } from '@finance-hub/domain/invoicing/components/invoice-summary-amount-bucket-card';
import { Skeleton, View, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { TIME_SERIES_BUCKET_MIN_WIDTH } from '@finance-hub/domain/invoicing/components/invoice-summary-time-series-bucket-card';
import { useTheme } from '@/contexts/theme-context';

/** Mirrors the populated row: three amount cards, six time-series cards. */
const SKELETON_CARDS: { key: string; minWidth: number }[] = [
  { key: 'skeleton-amount-0', minWidth: AMOUNT_BUCKET_MIN_WIDTH },
  { key: 'skeleton-amount-1', minWidth: AMOUNT_BUCKET_MIN_WIDTH },
  { key: 'skeleton-amount-2', minWidth: AMOUNT_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-0', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-1', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-2', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-3', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-4', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
  { key: 'skeleton-time-series-5', minWidth: TIME_SERIES_BUCKET_MIN_WIDTH },
];

export const InvoiceSummaryBucketsRowSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <XStack
      accessibilityLabel={i18n.t('loading')}
      flexWrap="wrap"
      gap="$12"
      width="100%"
    >
      {SKELETON_CARDS.map(({ key, minWidth }) => (
        <View
          borderColor="$borderPrimary"
          borderRadius="$12"
          borderWidth={1}
          flexBasis={minWidth}
          flexGrow={1}
          flexShrink={1}
          key={key}
          minWidth={minWidth}
          overflow="hidden"
        >
          <YStack gap="$4" padding="$12">
            <Skeleton
              borderRadius={theme.sk.radii.radiusRound}
              height={10}
              variant="rect"
              width={64}
            />
            <Skeleton
              borderRadius={theme.sk.radii.radiusRound}
              height={22}
              variant="rect"
              width={88}
            />
            <Skeleton
              borderRadius={theme.sk.radii.radiusRound}
              height={10}
              variant="rect"
              width={56}
            />
          </YStack>
        </View>
      ))}
    </XStack>
  );
};
